<div class="d-flex align-items-center justify-content-between" [ngClass]="{'pr-3': flex=='row' }" style="min-width: 560px;">
  <ng-container>
    <div *ngIf="!warranty" class="d-flex justify-content-between flex-column">
      <span style="font-size: 20px; color: var(--greenmix-light); pointer-events: none"> Sem período</span>
      <span style="font-weight: 500; font-size: 16px; color: var(--greenmix-light); pointer-events: none">
        Sem data de expiração</span
      >
    </div>

    <div *ngIf="warranty" class="d-flex justify-content-between flex-column">
      <span
        *ngIf="warrantyActive != 3"
        [ngStyle]="{ color: warrantyActive == 1 ? 'var(--green-base)' : 'var(--red-base)' }"
        style="font-size: 20px; pointer-events: none"
      >
        {{
          dateService.getTextDate(warrantyCurrent) == 0 ? 'Fim da Garantia' : dateService.getTextDate(warrantyCurrent)
        }}</span
      >
      <span
        *ngIf="warrantyActive == 3"
        style="color: var(--redmix-light); font-weight: 400; font-size: 20px; pointer-events: none"
      >
        Tempo Encerrado
      </span>
      <h4 class="mt-2" [ngStyle]="{ color: warrantyActive == 1 ? 'var(--greenmix-light)' : 'var(--red-base)' }">
        {{ warrantyActive == 3 ? 'expirou em' : 'expira em' }}
        {{ warranty | date: 'dd/MM/yyyy' }}
      </h4>
    </div>
  </ng-container>

  <ng-container>
    <progressbar
      *ngIf="warrantyActive == 1"
      class="mx-3"
      style="border-radius: 8px; height: 8px; width: 12em"
      [value]="warrantyProgress * 100"
      type="success"
    >
    </progressbar>
    <progressbar
      *ngIf="warrantyActive > 1"
      class="mx-3"
      style="border-radius: 8px; height: 8px; width: 12em"
      [value]="warrantyProgress * 100"
      type="danger"
    >
    </progressbar>
  </ng-container>

  <ng-container>
    <div *ngIf="!warranty" class="d-flex justify-content-between flex-column align-items-end">
      <span style="font-size: 20px; color: var(--gray-light); pointer-events: none"> Sem período</span>
      <span
        style="
          color: var(--red-base);
          font-weight: 500;
          font-size: 16px;
          color: var(--gray-light);
          pointer-events: none;
        "
      >
        Sem última edição</span
      >
    </div>

    <div *ngIf="warranty" class="d-flex justify-content-between flex-column align-items-end">
      <span *ngIf="warrantyActive != 3" style="font-size: 20px; color: var(--gray-light); pointer-events: none"
        >de {{ dateService.getTextDate(warrantyEnd) }}</span
      >
      <span
        *ngIf="warrantyActive == 3"
        style="color: var(--red-base); font-weight: 500; font-size: 16px; pointer-events: none"
        ><i class="fa-solid fa-lg fa-triangle-exclamation" style="margin-right: 8px"></i> Garantia Expirada</span
      >
      <h4 class="mt-2" style="color: var(--gray-light)">
        {{
          warrantyLastUpdate
            ? 'Última edição em ' + (warrantyLastUpdate | date: 'dd/MM/yyyy')
            : 'Última edição em ' + (today | date: 'dd/MM/yyyy')
        }}
      </h4>
    </div>
  </ng-container>
</div>
